import React from 'react'
import { useSelector } from 'react-redux'

import PageStepper from './PageStepper'
import AppLink from '../../atoms/AppLink/AppLink'
import { Environment } from '../../../environment/app-settings'
import Image from '../../atoms/Image/Image'
import PhoneNumber from '../../molecules/PhoneNumber/PhoneNumber'
import { AppState } from '../../../store'


import MainLogoColor from '../../../icons/images/main-logo-color.webp'
import  './SidebarStyles.scss'


/**
 * ORGANISM - Sidebar wyświetlany na stronie aplikacji.
 * Składa się z logo, Page Steppera oraz wrappera z numerem telefonu.
 */
const Sidebar = () => {
   const { phoneNumber, isPhoneAvailable, isPhoneVisibleOnPage } = useSelector((state: AppState) => state.lenConfigState.footerConfig)

   return (
      <aside className='page-sidebar-outer-wrapper'>
         <AppLink href={Environment.representativePageUrl} className='page-logo-wrapper' style={{marginBottom: 0}}>
            <Image src={MainLogoColor} alt="Logo Opena" width={166} height={30} />
         </AppLink>
         <PageStepper />
         <PhoneNumber phoneNumber={phoneNumber} isPhoneAvailable={isPhoneAvailable} isPhoneVisibleOnPage={isPhoneVisibleOnPage} />
      </aside>
   )
}

export default Sidebar